import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EmptyTableText, Table } from '../../../../../common-client2/src/components';
import { displayNotificationCustomTags } from '../../../store/appData';

const addDetailsToString = (/** @type {any} */ string) => `${string}Details`;

const columns = [
    {
        key: 'customTag',
        tKey: 'columns.customTag',
        sortable: true,
        flexGrow: 1,
        minWidth: 225,
    },
    {
        key: 'customTagDetails',
        tKey: 'columns.customTagDetails',
        sortable: true,
        flexGrow: 3,
        minWidth: 625,
    },
];

const NotificationTags = ({ requestType }) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'notifications.tags' });
    const dispatch = useDispatch();
    /** @type {EmploymentBillboard.AdminStore} */
    const { adminAppData, pendingTasks } = useSelector((state) => state);
    const { notificationCustomTags } = adminAppData;

    const mappedTags = notificationCustomTags[requestType]?.map((tag) => ({
        value: tag,
        customTag: t(tag),
        customTagDetails: t(addDetailsToString(tag)),
    }));

    useEffect(() => {
        if(!notificationCustomTags[requestType]){
            dispatch(displayNotificationCustomTags());
        }
    }, []);

    return (
        <Table
            data={mappedTags || []}
            id="tags-table"
            renderEmpty={() => <EmptyTableText text={t('noCustomTags')} />}
            rowClassName="table-row"
            disableSearch
            columns={columns}
            loading={!!pendingTasks}
            fillAvailableHeight
        />
    );
};
export default NotificationTags;
